import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mrp-order-list", { params });
}

const getAllForCSV = params => {
  return restApiMP.get("/api/mrp-order-list/csv", { params });
}

const mrpOrderListService = {
  getAll,
  getAllForCSV
};

export default mrpOrderListService;